import img_1 from '../assets/images/tra/1.webp';
export default function Immersive() {
  return (
    <div className="relative">
      <img src={img_1} alt="Hero background" className="w-full h-auto" />
    </div>
  )
}